<template>
	<div id="wrapper">
        <leftMenu />
        <AppContent />
        <logofModal />
    </div>
</template>

<script>
    import leftMenu   from "@/components/Template/menubar.vue";
    import AppContent from "@/components/Template/content.vue";
    import logofModal from "@/components/Modal/Logof.vue";

    export default { components: { leftMenu, AppContent, logofModal } }
</script>

<style lang="scss">
	@import "../../assets/sass/liga.scss";
</style>
